(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('FacilityBilling', FacilityBilling);

    FacilityBilling.$inject = ['$resource', 'DateUtils'];

    function FacilityBilling ($resource, DateUtils) {
        var resourceUrl =  'api/facility-billings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {method:'PUT'},
            'filter': {url: 'api/facility-billings/filter', method: 'GET', isArray: true}
        });
    }
})();
